<template>
  <!-- 二级问题 -->
  <div class="receipt">
    <top></top>
    <!-- <mt-header title="客服中心" class="nav-bar">
      <router-link to="/" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
      <img slot="right" src="../../assets/question-close-icon.png" alt="">
    </mt-header> -->
    <!-- 账号问题 -->
    <div class="receipt-content">
      <div class="hot-question">
        <div class="hot-top-content">
          <div class="hot-title">
            <span>{{questionName}}</span>
          </div>
        </div>
        <div class="hot-btm-content">
          <div class="hot-item-content" v-for="(item,i) in accountList" :key="i">
            <div class="hot-item" @click="itemClick(item)">
              <img src="../../assets/receipt-item-icon.png" class="img-icon" alt=""><span>{{ item.questionName }}</span><img src="../../assets/receipt-item-right.png" class="img-icon item-right" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '../../api/question'
import Top from '../common/top.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    Top
  },
  data() {
    return {
      accountList: [],
      questionName: '',
      homeType: -1
    }
  },
  computed: {
    ...mapGetters({
      chatType: 'chatType',
    }),
  },
  created() {
    this.init()
    this.homeType = sessionStorage.getItem('redirectTarget')
  },
  methods: {
    init() {
      Api.getTypeDetails({ visitorMd5Code: this.$route.query.v, id: this.$route.query.id }, res => {
        if (res.code === 1) {
          this.accountList = res.data.children
          this.questionName = res.data.questionName
        }
      })
    },
    itemClick(item) {
      this.$store.dispatch({
        type: 'getEnable',
        visitorMd5Code: this.$route.query.v,
      }).then(res => {
        if (this.homeType == 5) {
          this.$Points.point({code: '1001', type: '3', id: item.id});
        }
        switch(item.type) {
          // 外链
          case 1:
            location.href = item.skipUrl || item.url
            break;
          case 2:
            if (item.isAi) {
              if (this.$route.query.ailink == 'spirit') {
                this.$router.push({
                  path: '/spirit',
                  query: {
                    id: item.id,
                    v: this.$route.query.v,
                    source: this.$route.query.source,
                    chatType: this.chatType,
                    questionName: item.questionName
                  }
                })
              } else if (this.$route.query.ailink == 'imChat') {
                this.$router.push({
                  path: '/imChat',
                  query: {
                    id: item.id,
                    v: this.$route.query.v,
                    source: this.$route.query.source,
                    chatType: this.chatType,
                    questionName: item.questionName
                  }
                })
              }
            } else {
              this.$router.push({
                path: '/faqPage',
                query: {
                  type: 'type',
                  id: item.id,
                  v: this.$route.query.v
                }
              })
            }
            break;
          // 工单
          case 4:
            sessionStorage.setItem("navname", '二级页面');
            if (item.showNote) {
              this.$router.push({
                path: '/workinformation',
                query: {
                  name: item.workerOrderName,
                  source: 'type',
                  id: item.workerOrderId,
                  v: this.$route.query.v
                }
              })
            } else {
              this.$router.push({
                path: '/workcommit',
                query: {
                  name: item.workerOrderName,
                  id: item.workerOrderId,
                  source: this.$route.query.source,
                  v: this.$route.query.v
                }
              })
            }
            break;
        }
      })
    }
  }
}
</script>
<style scoped>
.receipt {
	min-height: 100vh;
	box-sizing: border-box;
	background: fixed url(/pc/static/assets/question-nav.png) no-repeat;
	background-size: 100% auto;
	background-color: #F8F9FC;
}
.receipt-content {
  padding: 0 15px 50px 15px;
}
.receipt .nav-bar {
	color: #333;
	background-color: transparent;
}
.receipt .nav-bar a {
	color: #333;
}
.receipt .nav-bar .mint-header-title {
	color: #333;
}
.receipt .nav-bar img {
	width: 20px;
	height: 20px;
}
.receipt .hot-question {
  padding: 12.5px 0;
  margin-top: 15px;
	margin-bottom: 18px;
  border-radius: 8px;
  background: #FFFFFF;
	position: relative;
}
.receipt .hot-question .hot-top-content {
	padding: 0 10px;
	display: flex;
	justify-content: space-between;
}
.receipt .hot-question .hot-top-content .hot-title {
	display: flex;
	align-items: center;
}
.receipt .hot-question .hot-top-content .hot-title span {
	font-size: 16px;
	margin-right: 6px;
}
.receipt .hot-question .hot-top-content .hot-title img {
	width: 12px;
}
.receipt .hot-question .hot-top-content .toggle-content {
	display: flex;
	align-items: center;
}
.receipt .hot-question .hot-top-content .toggle-content span {
	font-size: 12px;
	color: #007AFF;
}
.receipt .hot-question .hot-top-content .toggle-content img {
	width: 12px;
	margin-right: 6px;
}
.receipt .hot-question .hot-btm-content {
	display: flex;
	flex-wrap: wrap;
	padding: 0 5px;
	margin-top: 15px;
}
.receipt .hot-question .hot-btm-content .hot-item-content {
	width: 25%;
	padding: 0 5px;
	box-sizing: border-box;
}
.receipt .hot-question .hot-btm-content .hot-item-content .img-icon {
	height: 15px;
}
.receipt .hot-question .hot-btm-content .hot-item-content .img-icon.item-right {
	height: 10px;
}
.receipt .hot-question .hot-btm-content .hot-item {
	height: 35px;
	padding: 0 10px;
	margin-bottom: 8px;
	border: 1px solid #E5E9EF;
	border-radius: 8px;
	display: flex;
	align-items: center;
	position: relative;
}
.receipt .hot-question .hot-btm-content .hot-item span {
	flex: 1;
}
.receipt .hot-question .hot-btm-content .hot-item span {
	font-size: 12px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	padding-right: 5px;
	margin-left: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/question/receipt.vue?e484f8d4